import { useState } from 'react';
import { DraggableProvided } from 'react-beautiful-dnd';
import styled from 'styled-components';
import { BUTTON_VARIANTS, IconButton } from 'ui/button';
import { InputText } from 'ui/inputs';
import { Drag, Edit16 } from 'ui/icons';
import { useEditableFieldsContext } from '../context/EditableFieldsContext';
import { PushActionButton, PushContentDefinition } from '../../graphql/types';
import { SETTINGS_DISPLAY_CONTENT } from './constants';

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledDragIcon = styled(Drag)`
  transform: rotate(90deg);
`;

const HeaderTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledTitle = styled.div`
  padding-left: ${({ theme }) => theme.spacing.utils.pxToRem(14)};
`;

const EditIconWrapper = styled(IconButton)`
  height: ${({ theme }) => theme.spacing.utils.pxToRem(34)};
  padding-left: ${({ theme }) => theme.spacing.utils.pxToRem(10)};
  :focus::before {
    border: none;
  }
`;

type Props = {
  data: PushActionButton;
  index: number;
  draggableProvided: DraggableProvided;
};

export const EditableTitle = ({ data, index, draggableProvided }: Props) => {
  const { liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const pushMediumData = (liveTemplate?.mediumData || {}) as PushContentDefinition;
  const actionButtonData = (pushMediumData?.actionButtons || []) as PushActionButton[];
  const [editTitle, setEditTitle] = useState<boolean>(false);
  const { ids } = SETTINGS_DISPLAY_CONTENT.actionButtons;

  return (
    <TitleWrapper>
      <div {...draggableProvided.dragHandleProps}>
        <StyledDragIcon />
      </div>
      {editTitle ? (
        <InputText
          autoFocus
          id={ids.inputTextTitleId}
          onChange={(newTitle) => {
            const newActionButton = {
              ...data,
              title: newTitle,
            };
            actionButtonData[index] = newActionButton;
            setCurrentMediumField('actionButtons', actionButtonData);
          }}
          onBlur={() => setEditTitle(false)}
          maxLength={100}
          value={data.title || ''}
          data-test="editable-title-input-text"
        />
      ) : (
        <HeaderTitleContainer data-test="action-button-name-container">
          <StyledTitle>{data.title || ''}</StyledTitle>
          <EditIconWrapper
            data-test="editable-title-edit-button"
            onClick={() => setEditTitle(true)}
            variant={BUTTON_VARIANTS.GHOST}
          >
            <Edit16 />
          </EditIconWrapper>
        </HeaderTitleContainer>
      )}
    </TitleWrapper>
  );
};
